<nz-card class="header-card" nzSize="small" >
  <app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
  <div class="flex justify-between my-3">
    <h2 class="!text-lg xxsm:!text-2xl my-0">Judgments</h2>
  </div>
</nz-card>




<nz-card class="!my-4 ">
  <div class="max-w-[1100px] lg:h-[40px]  gap-3 flex justify-start items-center w-[100%] flex-col lg:flex-row">
    <div class="basis-[45%] w-full xl:basis-[55%] h-full">
      <nz-input-group nzSearch nzSize="large" [nzSuffix]="inputClearTpl" [nzAddOnAfter]="suffixButton">
        <input type="text" nz-input placeholder="Search Judgments" [(ngModel)]="searchValue"/>
      </nz-input-group>
      <ng-template #suffixButton>
        <button nz-button nzType="primary" nzSize="large" (click)="getCaseBySearch()" nzSearch>Search</button>
      </ng-template>
      <ng-template #inputClearTpl>
      <span
        nz-icon
        class="ant-input-clear-icon"
        nzTheme="fill"
        nzType="close-circle"
        *ngIf="searchValue"
        (click)="cancelSearch()"
      ></span>
      </ng-template>
    </div>
    <div
      class="basis-[45%] xl:basis-[35%]  h-full w-full flex justify-between items-center gap-3 flex-col xsm:gap-1 xsm:flex-row">
      <div class="h-[38px] w-full lg:h-full basis-[55%]">
        <nz-date-picker class="h-full w-full" [(ngModel)]="date" (ngModelChange)="onChange($event)"></nz-date-picker>
      </div>
      <div class="h-[38px] lg:h-full w-full basis-[45%]">

        <nz-select class="h-full w-full" nzSize="large" (ngModelChange)="getCasesByCourt($event)"
                   nzPlaceHolder="Select Court" [(ngModel)]="this.selectedCourt">
          <nz-option nzValue="Supreme Court" nzLabel="Supreme Court">Supreme Court</nz-option>
          <nz-option nzValue="Court of Appeal" nzLabel="Court of Appeal">Court of Appeal</nz-option>
          <nz-option nzValue="High Court" nzLabel="High Court">High Court</nz-option>
        </nz-select>

      </div>
    </div>
    <div class="basis-[10%] h-full   w-full">
      <button
        class="w-full py-2 lg:py-0 h-full outline-none border border-solid border-[#441752] text-[#441752] bg-transparent rounded-md"
        (click)="cancelSearch()">Reset
      </button>
    </div>
  </div>
</nz-card>
<nz-empty class="mt-10" *ngIf="this.data.length === 0"></nz-empty>
<div class="grid-container mt-4">
  <nz-card *ngFor="let case of this.data">
    <h5>{{case.court}}</h5>
    <p class="text-[#657786] text-sm font-[400]">{{this.formatDateTime(case.date)}}</p>
    <div class="mt-3 flex justify-start items-start w-full flex-col gap-1">
      <p class="text-[#262626] font-[450] ">Case Number : {{case.title}}</p>
      <p class="text-[#262626] font-[400] text-justify">{{case.content}}</p>
      <div *ngIf="this.case.caseFile">
          <a [href]="this.case.caseFile.url" target="_blank"><button nz-button nzSize="large" nzType="primary">View PDF</button></a>
      </div>
      <div class="mt-5">
        <a *ngFor="let link of this.case.externalLinks" [href]="link.link" target="_blank">
          <nz-tag nzColor="#55acee" class="tag">
            <span *ngIf="link?.name?.length < 15">{{link.name}}</span>
            <span *ngIf="link?.name?.length >= 15">{{link.name.substring(0,15)}}..</span>
            <span class="arrow" nz-icon nzType="arrow-up" nzTheme="outline"></span>
          </nz-tag>
        </a>
      </div>
    </div>
  </nz-card>

</div>

<div class="mt-4 flex justify-end">
  <nz-pagination class="mt-8" (nzPageIndexChange)="onCurrentPageDataChange($event)" [nzPageIndex]="currentPage"
                 [nzTotal]="totalDocs" [nzPageSize]="pageSize"></nz-pagination>
</div>
